import { render, staticRenderFns } from "./workAreaForm.vue?vue&type=template&id=58fbb584&scoped=true"
import script from "./workAreaForm.vue?vue&type=script&lang=js"
export * from "./workAreaForm.vue?vue&type=script&lang=js"
import style0 from "./workAreaForm.vue?vue&type=style&index=0&id=58fbb584&prod&lang=less&scoped=true"
import style1 from "./workAreaForm.vue?vue&type=style&index=1&id=58fbb584&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbb584",
  null
  
)

export default component.exports